const API_STACK = 'taxonomy';

export const GET_TAXONOMY = API_STACK;
